import { useState } from "react";

export function useResettablePage(resetDependency: unknown) {
  const [page, setPage] = useState(1);
  const [prevDependency, setPrevDependency] = useState(resetDependency);

  if (resetDependency !== prevDependency) {
    setPrevDependency(resetDependency);
    setPage(1);
  }

  return [page, setPage] as const;
}
